// src/pages/AAApplicationPage.jsx
import React, { useEffect, useState } from "react";
import Header from "./Header/header";
import { useNavigate } from "react-router-dom";
import callApi from "../../../utility/apiCaller";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "./Spinner/spinner";
import { setOffers } from "../../../store/app/appReducer";
import { AlertCircle } from "lucide-react";
import useUserEvent from "../../../hooks/setUserclickhook";
// Generic retry + validation wrapper
const callApiWithRetryAndTest = async (
  apiFunc,
  retries,
  delay,
  testFunc,
  errorMsg
) => {
  return await withRetry(
    async () => {
      const res = await apiFunc();
      console.log(res);
      if (testFunc && !testFunc(res)) {
        throw new Error(errorMsg || "Validation failed");
      }
      return res;
    },
    retries,
    delay
  );
};

const withRetry = async (fn, retries = 3, delay = 1000) => {
  let attempt = 0;
  while (attempt < retries) {
    try {
      return await fn();
    } catch (err) {
      attempt++;
      if (attempt >= retries) throw err;
      console.warn(`Retrying... attempt ${attempt}`);
      await new Promise((res) => setTimeout(res, delay * attempt)); // exponential backoff
    }
  }
};

export default function AAApplicationPage({
  aaUrl,
  appId,
  setcurrentStep,
  currentstep,
}) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = useSelector((state) => state.app.user);
  const aaSlice = useSelector((state) => state?.aa);
  let leadId = aaSlice?.internalLeadId;
  const applicationId = aaSlice?.appId;
  const dmiLeadId = aaSlice?.leadId;
  const [aaFailed, setAaFailed] = useState(false);
  const dispatch = useDispatch();
  const { trackUserEvent } = useUserEvent();

  useEffect(() => {
    const checkAAStatus = async () => {
      try {
        // Call API with retry and validation
        const res = await callApiWithRetryAndTest(
          () =>
            callApi(
              "v1/callback/list",
              "post",
              {
                filters: {
                  event: "AA_Callback",
                  Key: dmiLeadId,
                },
              },
              "loan-service"
            ),
          6, // max 60 retries
          10000, // 5s delay
          (res) => {
            const callbacks = res?.data?.callbackList || [];
            return callbacks.some((cb) => cb.Status === "Success");
          },
          "AA status not successful yet"
        );

        const DDRes = await callApiWithRetryAndTest(
          () =>
            callApi(
              "v1/callback/list",
              "post",
              {
                filters: {
                  event: "Dual_decision_Callback",
                  applicationid: applicationId,
                  Type: "Redecision",
                },
              },
              "loan-service"
            ),
          5, // max 60 retries
          5000, // 5s delay
          (res) => res && res.data && res.data.callbackCount > 0,
          "AA status not successful yet"
        );

        const latestOffer = DDRes?.data?.callbackList;
        const { OfferDetails } = latestOffer[0];


        dispatch(setOffers(latestOffer));

        // If success → update lead
        await callApi(
          `v1/lead/${leadId}/update-lead-new`,
          "post",
          {
            lead: {
              is_acc_aggregator_completed: true,
              steps_completed: 5,
              dmi_offers_details: [
                {
                  OfferDetails: OfferDetails,
                },
              ],
            },
          },
          "core",
          user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"
        );

        trackUserEvent("aa-offer-for-e2e", leadId);
        if (!OfferDetails.length > 0) {
          setcurrentStep(55)
        } else {
          setcurrentStep(7);
        }


      } catch (err) {
        console.error("AA check failed after retries", err);
        setLoading(false);
        setAaFailed(true);
        setcurrentStep(55);
      }
    };

    checkAAStatus();
  }, [appId, currentstep]);

  return (
    <div className="w-full max-w-[400px] mx-auto h-screen bg-gray-100 flex flex-col">
      {/* Header */}
      <Header />

      {/* Iframe */}
      {loading && (
        <div className="flex-1 h-full flex flex-col justify-center items-center ">
          <Spinner />
          <p className="leading-tight text-center">
            Please wait...
            <br />
            It may take up to 1 minute.
          </p>
        </div>
      )}
      {aaFailed && (
        <div className="absolute inset-0 flex flex-col items-center justify-center  z-10 p-6">
          <AlertCircle className="w-16 h-16 text-red-600 mb-4 animate-pulse" />
          <h2 className="text-2xl font-semibold text-red-700 mb-2">
            AA Rejected
          </h2>
          {/* <p className="text-red-600 text-center max-w-xs">
            Your Account Aggregator Failed. Please try again.
          </p> */}
        </div>
      )}
    </div>
  );
}
